import React, { useState, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import "./baseStyles.css"; 
import "./BigQuestionPage.css"; 
import { useNavigate, useParams } from "react-router-dom";  
const apiUrl = process.env.REACT_APP_API_URL;


const BigQuestionPage = () => {
  const [loginUserId, setLoginUserId] = useState("");
  const [question, setQuestion] = useState(null);
  const [editedQuestionText, setEditedQuestionText] = useState(""); 
  const [partnerResponses, setPartnerResponses] = useState([]);
  const [partnerLoginId, setPartnerLoginId] = useState(""); 
  const [error, setError] = useState("");
  const [infoMessage, setInfoMessage] = useState("");
  const navigate = useNavigate(); 
  const [campaignName, setCampaignName] = useState("");
  const [userId, setUserId] = useState("");  
  const [bigQuestionCampaigns, setBigQuestionCampaigns] = useState([]); 
  const { campaignName: urlCampaignName } = useParams(); // ✅ Get campaign from URL
  const [campaignEntry, setCampaignEntry] = useState(null);
  //const [campaignEntry, setCampaignEntry] = useState({});
  const [partnerEmail, setPartnerEmail] = useState("");
  const [showHowItWorks, setShowHowItWorks] = useState(false);
  const decodedCampaignName = decodeURIComponent(urlCampaignName || "");

  // --- for the tally
  const [showTally, setShowTally] = useState(false);
  const [tallyLoading, setTallyLoading] = useState(false);
  const [tallyError, setTallyError] = useState("");
  const [tallyData, setTallyData] = useState(null);

  const [confirmRemovePartner, setConfirmRemovePartner] = useState(false);
  const [pendingRemovePartnerLoginId, setPendingRemovePartnerLoginId] = useState("");
  const [removePartnerLoginId, setRemovePartnerLoginId] = useState("");

  const [showGroupMessageModal, setShowGroupMessageModal] = useState(false);
  const [groupMessageSubject, setGroupMessageSubject] = useState("");
  const [groupMessageText, setGroupMessageText] = useState("");
  const [groupMessageSending, setGroupMessageSending] = useState(false);



  const allowedNowUsers = [
    "24c8d4f8-e0d1-700b-91fe-340cedc4d1fb",
    "dummy"
  ];

  useEffect(() => {
    handleAuthAndFetchData();
  }, []);

  const handleAuthAndFetchData = async () => {

    clearStatusMessages();


    const idToken = localStorage.getItem("idToken");

    if (!idToken) {
      setError("User is not authenticated. Please log in.");
      navigate("/login");
      return;
    }

    try {
      const decodedToken = jwtDecode(idToken);

      if (decodedToken.exp * 1000 < Date.now()) {
        localStorage.removeItem("idToken");
        setError("Session expired. Please log in again.");
        navigate("/login");
        return;
      }

      const userId = decodedToken.sub;
      setUserId(userId);
      setLoginUserId(decodedToken["cognito:username"]);

      // ✅ Fetch campaigns and handle auto-selection
      await fetchAllCampaigns(userId, decodedCampaignName);


    } catch (error) {
      console.error("❌ Error decoding token:", error);
      setError("Authentication error. Please log in again.");
      localStorage.removeItem("idToken");
      navigate("/login");
    }
  };


  // List Leader section
  const [showEditModal, setShowEditModal] = useState(false);
  const [editOptions, setEditOptions] = useState({
    listLeaderPeriod: "",
    listLeaderTime: "",
    listLeaderDayOfWeek: "",
    listLeaderHrsAfterAItoRun: "",
    listLeaderReminderFlag: "",

  });

  useEffect(() => {
    if (campaignEntry) {
      setEditOptions({
        listLeaderPeriod: campaignEntry.listLeaderPeriod || "",
        listLeaderTime: campaignEntry.listLeaderTime || "",
        listLeaderDayOfWeek: campaignEntry.listLeaderDayOfWeek || "",
        listLeaderHrsAfterAItoRun: campaignEntry.listLeaderHrsAfterAItoRun || "4",
        listLeaderReminderFlag: campaignEntry.listLeaderReminderFlag || "",
      });
    }
  }, [campaignEntry]);


  const clearStatusMessages = () => {
    setError("");
    setInfoMessage("");
  };



// --- open & fetch ---
const openTallyLeaderboard = async () => {
  clearStatusMessages?.();
  setTallyError("");
  setShowTally(true);
  setTallyLoading(true);
  try {
    const idToken = localStorage.getItem("idToken");
    const res = await axios.post(
      `${apiUrl}`,
      { operation: "tally_bigq_ai_wins", userid: userId, campaignName },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    setTallyData(res.data || null);
  } catch (e) {
    console.error("tally_bigq_ai_wins error", e);
    setTallyError("Failed to load AI tally.");
  } finally {
    setTallyLoading(false);
  }
};



  // ✅ Fetch all campaigns and filter only "BigQuestion" campaigns
  const fetchAllCampaigns = async (userid, decodedCampaignNameFromUrl = null) => {
    const idToken = localStorage.getItem("idToken");
    clearStatusMessages();

    try {
      const response = await axios.post(
        `${apiUrl}`,
        {
          operation: "fetch_all",
          userid: userid,
        },
        {
          headers: { Authorization: `Bearer ${idToken}` },
        }
      );

      if (response.data && Array.isArray(response.data)) {
        const filteredCampaigns = response.data.filter(
          (c) => c.campaignListCampaignType === "BigQuestion"
        );

        setBigQuestionCampaigns(filteredCampaigns);

console.log("🔍 URL Campaign:", decodedCampaignNameFromUrl);
console.log("🔍 Available Campaigns:", filteredCampaigns.map(c => c.campaignName));



        // ✅ Auto-select campaign from URL if provided
        if (decodedCampaignNameFromUrl) {
          const matchedCampaign = filteredCampaigns.find(
            (c) => c.campaignName === decodedCampaignNameFromUrl
          );
          if (matchedCampaign) {
            setCampaignName(decodedCampaignNameFromUrl);
            fetchCurrentQuestion(userid, decodedCampaignNameFromUrl);
            setCampaignEntry(matchedCampaign);
            return;
          }
        }

        // ✅ Else: Auto-select if only one campaign exists
        if (filteredCampaigns.length === 1) {
          const onlyCampaign = filteredCampaigns[0].campaignName;
          setCampaignName(onlyCampaign);
          fetchCurrentQuestion(userid, onlyCampaign);
          setCampaignEntry(filteredCampaigns[0]);
        }
      }

    } catch (err) {
      console.error("❌ Error fetching campaigns:", err);

      if (
        err.response &&
        err.response.data &&
        err.response.data.message === "The incoming token has expired"
      ) {
        console.warn("🚨 Token expired. Redirecting to login...");
        localStorage.removeItem("idToken");
        setError("Session expired. Please log in again.");
        navigate("/login");
        return;
      }

      setError("Failed to fetch campaigns.");
    }
  };



  // ✅ Fetch the current question and partner responses
  const fetchCurrentQuestion = async (userId, campaign) => {
    try {

      clearStatusMessages();
      const idToken = localStorage.getItem("idToken");
      const response = await axios.post(
        `${apiUrl}`,
        {
          operation: "read_and_compare_current_item_big_question",
          userid: userId,
          campaignName: campaign,
        },
        {
          headers: { Authorization: `Bearer ${idToken}` },
        }
      );

      const data = response.data;

      if (data) {
        setQuestion(data);
        setEditedQuestionText(data.Answer1 || ""); 

        if (data.partnerResponses) {
          setPartnerResponses(data.partnerResponses);
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          setPartnerResponses([]);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        setError("No data available.");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }


      } catch (err) {
        console.error("❌ Error fetching campaigns:", err);

        // ✅ Handle expired token case
        if (err.response && err.response.data && err.response.data.message === "The incoming token has expired") {
          console.warn("🚨 Token expired. Redirecting to login...");
          localStorage.removeItem("idToken");
          setError("Session expired. Please log in again.");
          navigate("/login");
          return;
        }

        setError("Failed to fetch campaigns.");
      }
    };







  // ✅ Function to save the updated question text
  const handleSaveQuestionEdit = async () => {

    clearStatusMessages();

    if (!editedQuestionText.trim()) {
      setError("Answer cannot be empty.");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    try {
      const idToken = localStorage.getItem("idToken");
      await axios.post(
        `${apiUrl}`,
        {
          operation: "update_campaign_item",
          userid: userId,
          campaignName,
          campaignItemsId: question.campaignItemsId, 
          Answer1: editedQuestionText, 
        },
        { headers: { Authorization: `Bearer ${idToken}` } }
      );

      setInfoMessage("Answer updated successfully!");
      window.scrollTo({ top: 0, behavior: "smooth" });
      setQuestion((prev) => ({ ...prev, Answer1: editedQuestionText }));

      setPartnerResponses((prev) =>
        prev.map((resp) => {
          const isMe =
            resp.partnerLoginId === loginUserId || resp.partnerUserId === userId;
          return isMe ? { ...resp, Answer1: editedQuestionText } : resp;
        })
      );


      //await fetchCurrentQuestion(userId, campaignName);


      } catch (err) {
        console.error("❌ Error fetching campaigns:", err);

        // ✅ Handle expired token case
        if (err.response && err.response.data && err.response.data.message === "The incoming token has expired") {
          console.warn("🚨 Token expired. Redirecting to login...");
          localStorage.removeItem("idToken");
          setError("Session expired. Please log in again.");
          navigate("/login");
          return;
        }

        setError("Failed to fetch campaigns.");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };


 // ✅ Function to add a partner
  const handleAddPartner = async () => {

    clearStatusMessages();

    if (!partnerLoginId.trim()) {
      setError("Please enter a partner's login ID.");
      window.scrollTo({ top: 0, behavior: "smooth" });

      return;
    }

    try {
      const idToken = localStorage.getItem("idToken");
      await axios.post(
        `${apiUrl}`,
        {
          operation: "update_campaign_partners_big_question",
          userid: userId,
          campaignName,
          partnerLoginId,
        },
        { headers: { Authorization: `Bearer ${idToken}` } }
      );

      setInfoMessage(`Partner ${partnerLoginId} added successfully!`);
      window.scrollTo({ top: 0, behavior: "smooth" });
      setPartnerLoginId("");

    // ✅ Re-fetch the latest question and partner responses
      setTimeout(() => {
        fetchCurrentQuestion(userId, campaignName);
      }, 3000); // Delay 3 seconds



    //fetchCurrentQuestion(userId, campaignName);

      
    } catch (err) {
      console.error("Error adding partner:", err);
      window.scrollTo({ top: 0, behavior: "smooth" });

      //setError("Failed to add partner. Please try again.");


      // ✅ Pass the exact error message from the API response to the UI
      if (err.response && err.response.data && err.response.data.error) {
        setError(err.response.data.error);
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        setError("Failed to add partner. Please try again.");
        window.scrollTo({ top: 0, behavior: "smooth" });

      }
  

    }
  };



  // ✅ Function to invite a partner 
  const handleInvitePartner = async () => {

    clearStatusMessages();

    // need form field for here
    if (!partnerEmail.trim()) {
      setError("Please enter a partner's email address.");
      window.scrollTo({ top: 0, behavior: "smooth" });

      return;
    }

    if (!campaignName || campaignName.trim() === "") {
      setError("Please select a campaign before sending an invite.");
      window.scrollTo({ top: 0, behavior: "smooth" });

      return;
    }





try {
  const idToken = localStorage.getItem("idToken");
  const res = await axios.post(
    `${apiUrl}`,
    {
      operation: "send_invite_email_to_partner",
      userid: userId,
      campaignName,
      partnerEmail,
    },
    { headers: { Authorization: `Bearer ${idToken}` } }
  );

  // Prefer backend message (includes “previous invite was replaced”),
  // fall back to a simple local message.
  const msg =
    (res?.data && res.data.message) ||
    (typeof res?.data?.body === "string" && JSON.parse(res.data.body).message) ||
    `Invite sent to ${partnerEmail}.`;

  setInfoMessage(msg);
  window.scrollTo({ top: 0, behavior: "smooth" });
  setPartnerEmail("");
} catch (err) {
  console.error("Error inviting partner:", err);
  window.scrollTo({ top: 0, behavior: "smooth" });

  const apiErr =
    err?.response?.data?.error ||
    (typeof err?.response?.data?.body === "string" &&
      JSON.parse(err.response.data.body).error);

  setError(apiErr || "Failed to invite partner. Please try again.");
}










  };






const handleSendGroupMessage = async () => {
  clearStatusMessages();

  const subject = (groupMessageSubject || "").trim();
  const message = (groupMessageText || "").trim();

  if (!subject) {
    setError("Please enter a subject.");
    return;
  }

  if (!message) {
    setError("Please enter a message.");
    return;
  }

  if (!campaignName || campaignName.trim() === "") {
    setError("Please select a campaign before sending a group message.");
    return;
  }

  try {
    setGroupMessageSending(true);

    const idToken = localStorage.getItem("idToken");
    const res = await axios.post(
      `${apiUrl}`,
      {
        operation: "send_group_message",
        userid: userId,
        campaignName,
        subject,
        message,
      },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );

    const msg =
      res?.data?.message ||
      `Group message sent to ${res?.data?.sentCount ?? "the"} recipient(s).`;

    setInfoMessage(msg);
    window.scrollTo({ top: 0, behavior: "smooth" });

    setGroupMessageSubject("");
    setGroupMessageText("");
    setShowGroupMessageModal(false);
  } catch (err) {
    console.error("Error sending group message:", err);

    let apiErr = err?.response?.data?.error;
    if (!apiErr && typeof err?.response?.data?.body === "string") {
      try {
        apiErr = JSON.parse(err.response.data.body).error;
      } catch (parseErr) {
        console.warn("Could not parse error body:", parseErr);
      }
    }

    setError(apiErr || "Failed to send group message. Please try again.");
    window.scrollTo({ top: 0, behavior: "smooth" });
  } finally {
    setGroupMessageSending(false);
  }
};


const handleRemovePartner = async () => {
  clearStatusMessages();

  const loginToRemove = (pendingRemovePartnerLoginId || "").trim();
  if (!loginToRemove) {
    setError("Please enter a partner's login ID.");
    return;
  }

  try {
    const idToken = localStorage.getItem("idToken");

    // Step 1: Fetch the full userid from the login ID
    const lookupRes = await axios.get(
      `${apiUrl}?operation=fetch_customer_by_login&userid=${encodeURIComponent(loginToRemove)}`,
      { headers: { Authorization: `Bearer ${idToken}` } }
    );

    const fetchedUserId = lookupRes?.data?.[0]?.userid;
    if (!fetchedUserId) {
      setError("Could not find a user with that login ID.");
      return;
    }

    // Step 2: Call backend to remove their campaign
    await axios.post(
      `${apiUrl}`,
      {
        operation: "remove_big_question_campaign",
        userid: fetchedUserId,
        campaignName: `${fetchedUserId}_${campaignName.split("_").slice(1).join("_")}`, // reconstruct full name
      },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );

    setInfoMessage(`Partner ${loginToRemove} removed successfully!`);
    window.scrollTo({ top: 0, behavior: "smooth" });

    setRemovePartnerLoginId("");
    setPendingRemovePartnerLoginId("");
    setConfirmRemovePartner(false);




    

    // ✅ Re-fetch the latest question and partner responses
    setTimeout(() => {
      fetchCurrentQuestion(userId, campaignName);
    }, 3000);

  } catch (err) {
    console.error("Partner removal failed:", err);
    if (err.response?.data?.error) {
      setError(err.response.data.error);
    } else {
      setError("Failed to remove partner.");
    }
  }
};






const handleUpdateOptions = async () => {
  clearStatusMessages();

  try {
    const idToken = localStorage.getItem("idToken");

    await axios.post(
      `${apiUrl}`,
      {
        operation: "update_list_item",
        userid: userId,
        campaignName,
        listLeaderPeriod: editOptions.listLeaderPeriod,
        listLeaderTime: editOptions.listLeaderTime,
        listLeaderDayOfWeek: editOptions.listLeaderDayOfWeek,
        listLeaderDayOfMonth: editOptions.listLeaderDayOfMonth,
        listLeaderNthWeekday: editOptions.listLeaderNthWeekday,
        listLeaderHrsAfterAItoRun: editOptions.listLeaderHrsAfterAItoRun,
        listLeaderReminderFlag: editOptions.listLeaderReminderFlag,

      },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );

    setShowEditModal(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setInfoMessage("Big Question options updated successfully!");
    await fetchCurrentQuestion(userId, campaignName);
    await fetchAllCampaigns(userId, campaignName);

  } catch (err) {
    console.error("Error updating options:", err);
    setError("Failed to update options. Please check your entries and try again.");
  }
};



  // Create 24-hour options with 12-hour display labels
  const hoursOptions = Array.from({ length: 24 }, (_, hour) => {
    const value = hour.toString().padStart(2, "0") + ":00"; // "00:00" to "23:00"
    const displayHour = hour % 12 === 0 ? 12 : hour % 12;
    const suffix = hour < 12 ? "AM" : "PM";
    const label = `${displayHour}:00 ${suffix}`; // "1:00 PM", etc.
    return { value, label };
  });


  const aiSummaryText = (question?.aiReview?.summary || question?.aiSummary || "").trim();
  const aiBestResponse = (
      question?.aiReview?.best_response ||
      question?.aiReview?.bestResponse ||
      question?.aiBestResponse ||
      ""
    ).trim();

  const normalizeAnswer = (value) => (value || "").trim();
  const aiReady = !!aiSummaryText;

  // -------------------------------------------------------
  // Big Question leaderboard transition support.
  //
  // New backend shape:
  //   tallyData.standings = [
  //     {
  //       userId,
  //       firstName,
  //       loginId,
  //       best10Score,
  //       firsts,
  //       seconds,
  //       thirds,
  //       played
  //     }
  //   ]
  //
  // Until the backend tally is upgraded, continue to accept
  // the existing tallyData.winners [{ wins, ... }] response.
  // Existing wins are treated/displayed as historical 1st places.
  // -------------------------------------------------------

  const hasNewTallyScoring =
    Array.isArray(tallyData?.standings);

  const tallyRows = hasNewTallyScoring
    ? [...(tallyData?.standings || [])].sort(
        (a, b) =>
          (Number(b?.best10Score) || 0) -
            (Number(a?.best10Score) || 0) ||
          (Number(b?.firsts) || 0) -
            (Number(a?.firsts) || 0) ||
          (Number(b?.seconds) || 0) -
            (Number(a?.seconds) || 0)
      )
    : [...(tallyData?.winners || [])]
        .sort(
          (a, b) =>
            (Number(b?.wins) || 0) -
            (Number(a?.wins) || 0)
        )
        .map((w) => ({
          ...w,
          firsts: Number(w?.wins) || 0,
        }));





  return (



    <div className="container">


<div className="header-with-info">
  <h5 className="section-header">
    the Big Question
    <span
      className="info-icon"
      title="How It Works"
      onClick={() => setShowHowItWorks(true)}
    >
      ℹ️
    </span>
  </h5>
</div>







  <br/>


      {error && <p className="error-message">{error}</p>}
      {infoMessage && <p className="success-message">{infoMessage}</p>}



{bigQuestionCampaigns.length > 1 && (
  <div className="form-group dropdown-container">

    <select
      id="big-question-select"
      className="compact-select"
      value={campaignName}
      onChange={(e) => {
        const selectedName = e.target.value;
        setCampaignName(selectedName);


        fetchCurrentQuestion(userId, selectedName);
        const matched = bigQuestionCampaigns.find(c => c.campaignName === selectedName);
        if (matched) setCampaignEntry(matched);
      }}
    >

      <option value="">-- Select Campaign --</option>


        {bigQuestionCampaigns.map((c) => {
          let displayName = c.campaignName;

          // Remove "userId_" prefix if present
          if (displayName.startsWith(`${userId}_`)) {
            displayName = displayName.replace(`${userId}_`, "");
          }

          // Remove "bigquestion_" prefix if present
          if (displayName.toLowerCase().startsWith("bigquestion_")) {
            displayName = displayName.replace(/^bigquestion_/i, "");
          }

          return (
            <option key={c.campaignName} value={c.campaignName}>
              {displayName}
            </option>
          );
        })}




    </select>
  </div>
)}





    {question && (
      <h3 className="question-text">{question.campaignItemsText}</h3>
    )}


<br/><br/>


      {question && (!question.aiReview || !question.aiReview.summary) && (
        <div className="card">
          <textarea
            className="edit-question-text"
            value={editedQuestionText}
            onChange={(e) => setEditedQuestionText(e.target.value)}
            rows="3"
            placeholder="Write your answer here..."
          />
          <button className="save-button" onClick={() => handleSaveQuestionEdit()}>
            Save Answer
          </button>
        </div>
      )}




{/* Partner responses */}
{Array.isArray(partnerResponses) && partnerResponses.length ? (
  <div className="partner-answers">
    <br />
    <h4>Responses:</h4>

    <div className="response-list">
      {partnerResponses.map((p, i) => {
        const isMe = p?.partnerLoginId === loginUserId;
        const youAnswered = !!(question?.Answer1 || "").trim();

        let display;

        if (!p?.Answer1) {
          display = "No response yet";
        } else if (isMe) {
          display = p.Answer1;
        } else if (!youAnswered) {
          display = "Answer locked until you respond";
        } else if (!aiReady) {
          display = "Responses are hidden until the AI summary is ready";
        } else {
          display = p.Answer1;
        }

        const showAiPick =
          aiReady &&
          !!p?.Answer1 &&
          normalizeAnswer(p.Answer1) === normalizeAnswer(aiBestResponse);

        const placement = Number(
          p?.bigQuestionPlacement ||
          p?.placement ||
          0
        );

        const placementBadge =
          placement === 1
            ? "🥇 1st"
            : placement === 2
            ? "🥈 2nd"
            : placement === 3
            ? "🥉 3rd"
            : "";

        return (
          <div
            key={i}
            className={`response-card ${showAiPick ? "ai-pick-card" : ""}`}
          >
            <div className="response-header-row">

              <div className="response-header">
                {p?.partnerFirstName || p?.partnerLoginId || "Unknown"}:
              </div>
              
              {placementBadge ? (
                <span className="ai-pick-badge">{placementBadge}</span>
              ) : (
                showAiPick && <span className="ai-pick-badge">🏆 AI Pick</span>
              )}
            </div>
            <div className="response-body">{display}</div>
          </div>
        );
      })}
    </div>

    {aiReady && (
      <div className="response-card" style={{ marginTop: 12 }}>
        <div className="response-header">AI Summary:</div>
        <div className="response-body">{aiSummaryText}</div>
      </div>
    )}
  </div>
) : (
  <p>No partner responses yet.</p>
)}





<br/><br/>

{campaignEntry?.listLeader && (
  <div className="card">
    <h2 className="section-header">Manage Partners</h2>

    <div className="partner-row">
      <label htmlFor="partnerEmail">Invite Partner (Email)</label>
      <div className="partner-input-group">
        <input
          id="partnerEmail"
          type="email"
          placeholder="e.g. partner@example.com"
          value={partnerEmail}
          onChange={(e) => setPartnerEmail(e.target.value)}
        />
        <button className="save-button" onClick={handleInvitePartner}>Invite Partner</button>
      </div>
    </div>


    <br/>
    <div className="partner-row">
      <label htmlFor="partnerLoginId">Add Partner (Login ID)</label>
      <div className="partner-input-group">
        <input
          id="partnerLoginId"
          type="text"
          placeholder="e.g. partner123"
          value={partnerLoginId}
          onChange={(e) => setPartnerLoginId(e.target.value)}
        />
        <button className="save-button" onClick={handleAddPartner}>Add Partner</button>
      </div>
    </div>

    <br/>


    <br/>


<div className="partner-row">
  <label htmlFor="removePartnerLoginId">Remove Partner (Login ID)</label>
  <div className="partner-input-group">
    <input
      id="removePartnerLoginId"
      type="text"
      placeholder="e.g. partner123"
      value={removePartnerLoginId}
      onChange={(e) => setRemovePartnerLoginId(e.target.value)}
    />
    <button
      className="save-button"
      onClick={() => {
        clearStatusMessages();
        if (!removePartnerLoginId.trim()) {
          setError("Please enter a partner's login ID.");
          return;
        }
        setPendingRemovePartnerLoginId(removePartnerLoginId.trim());
        setConfirmRemovePartner(true);
      }}
    >
      Remove Partner
    </button>
  </div>
</div>





    <br/><br/>

    <div className="button-group list-leader-options-wrapper">
      <button
        className="save-button list-leader-button"
        onClick={() => {
          clearStatusMessages();
          setShowGroupMessageModal(true);
        }}
      >
        Send Group Message
      </button>
    </div>

    <br/>


    {question && (
      <div className="button-group list-leader-options-wrapper">
        <button
          className="save-button list-leader-button"
          onClick={() => setShowEditModal(true)}
        >
          List Leader Options
        </button>
      </div>
    )}
  </div>
)}









{/* 📣 Send Group Message Modal */}
{showGroupMessageModal && (
  <div className="modal">
    <div className="modal-content">
      <div className="edit-options-container">
        <h3>Send Group Message</h3>

        <p style={{ fontSize: "0.85rem", color: "#666", marginTop: 0 }}>
          This will email all active members of this Big Question group.
        </p>

        <label>Subject:
          <input
            type="text"
            value={groupMessageSubject}
            onChange={(e) => setGroupMessageSubject(e.target.value)}
            placeholder="e.g. Schedule update"
          />
        </label>

        <label>Message:
          <textarea
            className="edit-question-text"
            value={groupMessageText}
            onChange={(e) => setGroupMessageText(e.target.value)}
            rows="6"
            placeholder="Type your message to the group..."
          />
        </label>

        {error && (
          <div className="error-message" style={{ marginTop: "10px" }}>
            {error}
          </div>
        )}

        <div className="button-group">
          <button
            className="save-button"
            onClick={handleSendGroupMessage}
            disabled={groupMessageSending}
          >
            {groupMessageSending ? "Sending..." : "Send Message"}
          </button>
          <button
            className="save-button"
            onClick={() => {
              setShowGroupMessageModal(false);
              setGroupMessageSubject("");
              setGroupMessageText("");
              clearStatusMessages();
            }}
            disabled={groupMessageSending}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)}


{showEditModal && (
  <div className="modal">
    <div className="modal-content">
      <div className="edit-options-container">
        <h3>Edit Big Question Options</h3>



        <label>How often to run:
          <select
            value={editOptions.listLeaderPeriod}
            onChange={(e) =>
              setEditOptions({ ...editOptions, listLeaderPeriod: e.target.value })
            }
          >
            <option value="never">Never</option>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            {allowedNowUsers.includes(userId) && (
              <option value="Now">Now</option>
            )}
          </select>
        </label>




        <label>What time of day to run:
          <select
            value={editOptions.listLeaderTime}
            onChange={(e) =>
              setEditOptions({ ...editOptions, listLeaderTime: e.target.value })
            }
          >
            <option value="">-- Select Time --</option>
            {hoursOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label} (Central)
              </option>
            ))}
          </select>
        </label>

        {editOptions.listLeaderPeriod === "weekly" && (
          <label>Day of the week:
            <select
              value={editOptions.listLeaderDayOfWeek}
              onChange={(e) =>
                setEditOptions({ ...editOptions, listLeaderDayOfWeek: e.target.value })
              }
            >
              <option value="Sunday">Sunday</option>
              <option value="Monday">Monday</option>
              <option value="Tuesday">Tuesday</option>
              <option value="Wednesday">Wednesday</option>
              <option value="Thursday">Thursday</option>
              <option value="Friday">Friday</option>
              <option value="Saturday">Saturday</option>
            </select>
          </label>
        )}

        {editOptions.listLeaderPeriod === "monthly" && (
          <>
            <label>Day of the month (1–31):
              <input
                type="number"
                min="1"
                max="31"
                value={editOptions.listLeaderDayOfMonth || ""}
                onChange={(e) =>
                  setEditOptions({ ...editOptions, listLeaderDayOfMonth: e.target.value })
                }
              />
            </label>

            <label>Or Nth Weekday of Month:
              <select
                value={editOptions.listLeaderNthWeekday || ""}
                onChange={(e) =>
                  setEditOptions({ ...editOptions, listLeaderNthWeekday: e.target.value })
                }
              >
                <option value="">-- Optional --</option>
                <option value="first_monday">First Monday</option>
                <option value="second_monday">Second Monday</option>
                <option value="third_monday">Third Monday</option>
                <option value="first_tuesday">First Tuesday</option>
                <option value="third_tuesday">Third Tuesday</option>
                <option value="first_wednesday">First Wednesday</option>
                <option value="third_wednesday">Third Wednesday</option>

              </select>
            </label>
          </>
        )}

        <label>Hours after AI Review to start next question:
          <input
            type="number"
            value={editOptions.listLeaderHrsAfterAItoRun}
            onChange={(e) =>
              setEditOptions({ ...editOptions, listLeaderHrsAfterAItoRun: e.target.value })
            }
            min="0"
          />
        </label>

{String(editOptions.listLeaderHrsAfterAItoRun) === "0" && (
  <p style={{
    fontSize: "0.75rem",
    color: "#666",
    marginTop: "4px",
    fontStyle: "italic"
  }}>
    * With 0 hours, the next question will be released at the next hourly update.
  </p>
)}

        <label>Enable Reminder Emails:
          <select
            value={editOptions.listLeaderReminderFlag || "true"}
            onChange={(e) =>
              setEditOptions({ ...editOptions, listLeaderReminderFlag: e.target.value })
            }
          >
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </label>
        <p style={{
          fontSize: "0.75rem",
          color: "#666",
          marginTop: "4px",
          fontStyle: "italic"
        }}>
          * We will send a reminder to folks that have not answered for Daily and Weekly Campaigns, 24 hours before the AI run
        </p>
        <br />




        <div className="read-only-fields">
          <h4>Current Settings</h4>
          <p><strong>Period:</strong> {campaignEntry.listLeaderPeriod || "Not Set"}</p>

          {campaignEntry.listLeaderPeriod === "never" ? (
              <p><strong>Status:</strong> Paused — choose a schedule to begin</p>
            ) : (
              <p>
                <strong>Last Run:</strong>{" "}
                {campaignEntry.listLeaderLastRun || "No Previous Runs"}
              </p>
            )}




          <p><strong>Configured Time of Day:</strong> {campaignEntry.listLeaderTime || "Not Set"}</p>
          <p><strong>Date Added as List Leader:</strong> {campaignEntry.listLeaderDateAdded || "Not Set"}</p>
          <p><strong>Hours after AI to move to next question:</strong> {campaignEntry.listLeaderHrsAfterAItoRun || "Not Set"}</p>
          <p><strong>Reminder Emails Enabled:</strong> {campaignEntry.listLeaderReminderFlag === "false" ? "No" : "Yes"}</p>

        </div>


        {error && (
          <div className="error-message" style={{ marginTop: "10px" }}>
            {error}
          </div>
        )}





        <div className="button-group">
          <button className="save-button" onClick={handleUpdateOptions}>Save Changes</button>
          <button className="save-button" onClick={() => setShowEditModal(false)}>Cancel</button>
        </div>
      </div>
    </div>
  </div>
)}


<br></br>




<div className="button-row">
  <button className="save-button" onClick={openTallyLeaderboard}>
    See how we are doing
  </button>
  <button className="save-button" onClick={() => navigate("/big-question-history")}>
    History
  </button>
</div>




<br></br>
<button className="save-button" onClick={() => navigate("/list-manager")}>
  Back to Campaigns
</button>







{showHowItWorks && (
  <div className="modal-overlay" onClick={() => setShowHowItWorks(false)}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-content" style={{ textAlign: "left" }}>
        <h3>How the Big Question Works</h3>

        <ul className="how-it-works-list">
          <li>Everyone gets the same question.</li>
          <li>A round can move forward once at least half of the group has answered.</li>
          <li>Answers are compared and the top three earn points.</li>
          <li>Longer answers do not get an advantage — a great answer can be one sentence.</li>
        </ul>

        <h4 style={{ marginTop: "18px", marginBottom: "8px" }}>
          Scoring
        </h4>

        <table className="items-table">
          <thead>
            <tr>
              <th>Finish</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>🥇 1st Place</td>
              <td>5</td>
            </tr>
            <tr>
              <td>🥈 2nd Place</td>
              <td>3</td>
            </tr>
            <tr>
              <td>🥉 3rd Place</td>
              <td>1</td>
            </tr>
          </tbody>
        </table>

        <h4 style={{ marginTop: "18px", marginBottom: "6px" }}>
          The Scoreboard
        </h4>

        <p style={{ marginTop: 0 }}>
          The scoreboard shows your <strong>Best 10 Score</strong>,
          1st-, 2nd-, and 3rd-place finishes, and questions played.
        </p>

        <p style={{ marginBottom: 0 }}>
          Your Best 10 Score is the total of your 10 best scoring
          results. Once you have more than 10 scoring finishes, a
          stronger new finish can replace one of your lower results.
          Your placement totals and questions played continue to
          accumulate throughout the campaign.
        </p>

        <div style={{ textAlign: "center", marginTop: "16px" }}>
          <button
            className="save-button"
            onClick={() => setShowHowItWorks(false)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}



{/* Tally Modal */}
{showTally && (
  <div className="modal-overlay" onClick={() => setShowTally(false)}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-content" style={{ textAlign: "left" }}>
        <h3>
          🏆 Big Question Scoreboard
          <button
            type="button"
            onClick={() => {
              setShowTally(false);
              setShowHowItWorks(true);
            }}
            style={{
              marginLeft: "10px",
              border: "none",
              background: "none",
              cursor: "pointer",
              fontSize: "0.8rem",
              textDecoration: "underline"
            }}
          >
            Scoring Help
          </button>
        </h3>

        {tallyLoading && <div>Loading…</div>}

        {!tallyLoading && tallyError && (
          <div className="error-message">{tallyError}</div>
        )}

        {!tallyLoading && !tallyError && tallyData && (
          <>
{/*}
            <div style={{ fontSize: "0.9rem", marginBottom: 8 }}>
              <strong>Campaign:</strong>{" "}
              {tallyData.campaignName?.replace(`${userId}_`, "") || campaignName}
              {"  "} | {"  "}
              <strong>Sequences with AI pick:</strong>{" "}
              {tallyData.consideredSequences}/{tallyData.totalSequences}
            </div>
*/}

            <table className="items-table">
              <thead>
                {hasNewTallyScoring ? (
                  <tr>
                    <th>User</th>
                    <th>Best 10</th>
                    <th>1st</th>
                    <th>2nd</th>
                    <th>3rd</th>
                    <th>Played</th>
                  </tr>
                ) : (
                  <tr>
                    <th>User</th>
                    <th>1st Places</th>
                  </tr>
                )}
              </thead>

              <tbody>
                {tallyRows.map((w) => (
                  <tr key={w.userId || w.loginId || w.firstName}>
                    <td>{w.firstName || w.loginId || w.userId}</td>

                    {hasNewTallyScoring ? (
                      <>
                        <td>{w.best10Score ?? 0}</td>
                        <td>{w.firsts ?? 0}</td>
                        <td>{w.seconds ?? 0}</td>
                        <td>{w.thirds ?? 0}</td>
                        <td>{w.played ?? 0}</td>
                      </>
                    ) : (
                      <td>{w.firsts ?? 0}</td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>

            {!hasNewTallyScoring && (
              <div
                style={{
                  fontSize: "0.72rem",
                  color: "#666",
                  marginTop: "8px",
                }}
              >
                Existing wins are shown as 1st-place finishes.
                New scoring will appear here as new questions are processed.
              </div>
            )}


            <div style={{ fontSize: "0.7rem", marginBottom: 8, marginTop: 12 }}>
              <strong>Campaign totals</strong>{" "}
              {tallyData.consideredSequences}/{tallyData.totalSequences}
            </div>


          </>
        )}

        <div style={{ textAlign: "center", marginTop: 16 }}>
          <button className="save-button" onClick={() => setShowTally(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}





{/* ❌ Remove Partner Confirm Modal */}
{confirmRemovePartner && (
  <div className="modal">
    <div className="modal-content">
      <p>
        Are you sure you want to remove{" "}
        <strong>{pendingRemovePartnerLoginId}</strong> from this campaign?
      </p>
      <div className="button-group">
        <button className="save-button" onClick={handleRemovePartner}>
          Yes, Remove
        </button>
        <button
          className="save-button"
          onClick={() => {
            setConfirmRemovePartner(false);
            setPendingRemovePartnerLoginId("");
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}







    </div>
  );
};

export default BigQuestionPage;
